import React from "react"
import SwitchButtons from "@kiwicom/frontend-common/components/SwitchButtons/SwitchButtons"

import DebugTools from "./DebugTools"
import Splitster from "./Splitster"
import ChangeAPI from "./ChangeAPI"
import OtherDebugInfo from "./OtherDebugInfo"
import DarwinMockUI from "./DarwinDebug/DarwinMockUI"

const SWITCH_BUTTONS_OPTIONS = [
  {
    key: "tools",
    name: "Tools",
  },
  {
    key: "splitster",
    name: "Splitster",
  },
  {
    key: "darwin",
    name: "Darwin (A/B)",
  },
  {
    key: "other",
    name: "Other",
  },
  {
    key: "changeAPI",
    name: "Change API",
  },
]

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props = Record<any, any>

type State = {
  tab: string
}

export default class DebugModal extends React.Component<Props, State> {
  state = {
    tab: "tools",
  }

  handleSwitchButtonsChange = (tab: string) => {
    this.setState({ tab })
  }

  render() {
    const { tab } = this.state

    return (
      <div className="DebugModal">
        <SwitchButtons
          onChange={this.handleSwitchButtonsChange}
          fullwidth
          // @ts-expect-error: Flow to TS migration.
          options={SWITCH_BUTTONS_OPTIONS}
          active={tab}
        />

        {tab === "tools" && <DebugTools />}
        {tab === "splitster" && <Splitster />}
        {tab === "darwin" && <DarwinMockUI />}
        {tab === "changeAPI" && <ChangeAPI />}
        {tab === "other" && <OtherDebugInfo />}
      </div>
    )
  }
}
